import React from "react";
import { Helmet } from "react-helmet-async";

const CardDetailForm = () => {
  return (
    <>
    <Helmet>
              <title>Card Details</title>
              <meta
                name="description"
                content={`Welcome to My Account page`}
              />
            </Helmet>

    <div className="w-full px-4 md:px-8 lg:px-16 py-8">
      <h1 className="text-center font-bold text-2xl md:text-3xl mb-10">
        Card Details
      </h1>

      <form className="space-y-12">

        {/* ================= Payment Information ================= */}
        <div>
          <h2 className="text-xl font-semibold mb-6 border-b pb-2">
            Payment Information
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            <input
              type="text"
              placeholder="Card Number"
              className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-black md:col-span-2"
            />

            <input
              type="text"
              placeholder="Name on Card"
              className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              placeholder="Expiry Month/Year"
              className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-black"
            />

            <input
              type="text"
              placeholder="CVV / CVC"
              className="w-full border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-black"
            />

          </div>
        </div>

        {/* ================= Submit Button ================= */}
        <div className="text-start">
          <button
            type="submit"
            className="bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition-all duration-300"
          >
            Save Card
          </button>
        </div>

      </form>
    </div>
        </>
  );
};

export default CardDetailForm;